import { EditorType } from '../model/Roles';
import {
  fetchAdvertisements,
  fetchCarpools,
  fetchNews,
  fetchPages,
  fetchReports,
  fetchRevisionsExcerpt,
  fetchScheduledNotifications,
  fetchUsers,
  getTopics,
} from './api';
import { loadPrefetched, prefetch } from './prefetch';

interface TabContext {
  sessionToken: string;
  festivalId: string;
  versionId: string;
}

/** Everything a live tab loads as it opens, by the name it loads it under (see loadTabData) */
const TAB_LOADS: Partial<Record<EditorType, (context: TabContext) => Record<string, () => Promise<unknown>>>> = {
  news: ({ sessionToken, festivalId }) => ({ news: () => fetchNews(sessionToken, festivalId) }),
  pages: ({ sessionToken, festivalId }) => ({ pages: () => fetchPages(sessionToken, festivalId) }),
  advertisements: ({ sessionToken, festivalId }) => ({
    advertisements: () => fetchAdvertisements(sessionToken, festivalId),
  }),
  carpools: ({ sessionToken, festivalId }) => ({ carpools: () => fetchCarpools(sessionToken, festivalId) }),
  reporting: ({ sessionToken, festivalId }) => ({ reports: () => fetchReports(sessionToken, festivalId) }),
  users: ({ sessionToken, festivalId }) => ({ users: () => fetchUsers(sessionToken, festivalId) }),
  notifications: ({ sessionToken, festivalId }) => ({
    topics: () => getTopics(sessionToken, festivalId),
    scheduledNotifications: () => fetchScheduledNotifications(sessionToken, festivalId),
  }),
  history: ({ sessionToken, festivalId, versionId }) => ({
    [`revisions/${versionId}`]: () => fetchRevisionsExcerpt(sessionToken, festivalId, versionId),
  }),
};

/** Starts loading what a tab shows, as the pointer reaches its sidebar entry */
export function prefetchTab(tab: EditorType, context: TabContext) {
  Object.entries(TAB_LOADS[tab]?.(context) ?? {}).forEach(([name, load]) => prefetch(`${context.festivalId}/${name}`, load));
}

/** What a tab shows, by the name TAB_LOADS gives it: its prefetch when there's a fresh one, else a new load */
export function loadTabData<T>(festivalId: string, name: string, load: () => Promise<T>): Promise<T> {
  return loadPrefetched(`${festivalId}/${name}`, load);
}
